

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 21 21","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, rest), ["\n    ", h('g', {"id":"svg-recording-stop-circle-WVa6d7V","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}, ["\n        ", h('path', {"d":"M10.5,0 C16.2989899,0 21,4.70101013 21,10.5 C21,16.2989899 16.2989899,21 10.5,21 C4.70101013,21 0,16.2989899 0,10.5 C0,4.70101013 4.70101013,0 10.5,0 Z M15,6 L6,6 L6,15 L15,15 L15,6 Z","id":"svg-recording-stop-circle-jTGVLxo","fill":"currentColor"}, []), "\n    "]), "\n"]);
};

        